import {Mic, MicOff} from 'lucide-react'
import React from 'react'
import {useIntl} from 'react-intl'

interface VoiceMicButtonProps {
  isListening: boolean
  disabled?: boolean
  onClick: () => void
  hasError?: boolean
  className?: string
}

const VoiceMicButton: React.FC<VoiceMicButtonProps> = ({
  isListening,
  disabled = false,
  onClick,
  hasError = false,
  className = '',
}) => {
  const intl = useIntl()

  const getAriaLabel = () => {
    if (isListening) {
      return intl.formatMessage({id: 'CHAT.VOICE.STOP_RECORDING'})
    }
    return intl.formatMessage({id: 'CHAT.VOICE.START_RECORDING'})
  }

  const baseClass = 'voice-mic-button'
  const stateClass = isListening ? 'listening' : hasError ? 'error' : 'idle'
  const disabledClass = disabled ? 'disabled' : ''

  const combinedClassName =
    `${baseClass} ${baseClass}--${stateClass} ${disabledClass} ${className}`.trim()

  return (
    <button
      type='button'
      onClick={onClick}
      disabled={disabled}
      aria-label={getAriaLabel()}
      aria-pressed={isListening}
      title={getAriaLabel()}
      className={combinedClassName}
    >
      {hasError ? <MicOff size={20} /> : <Mic size={20} />}
    </button>
  )
}

export default React.memo(VoiceMicButton)
